import { ActionArgs } from '../action/ActionArgs'
import { Field, InputType } from 'type-graphql'

@InputType()
export class UpdateTemplatesFavoriteServiceArgs extends ActionArgs {
  @Field(() => String)
  userId: string

  @Field(() => String)
  value: string
}
